<template>
  <!-- 当前商品绑定的辅料列表 -->
  <div v-if="materials.length" class="material-section">
    <!-- 辅料列表标题和收起展开按钮 -->
    <div class="material-toolbar">
      <span>辅料列表</span>
      <el-button type="text" size="mini" @click="toggleExpanded">
        {{ expanded ? '收起' : '展开' }}
        <i :class="expanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
      </el-button>
    </div>
    <!-- 辅料卡片内容根据当前展开状态显示 -->
    <div v-show="expanded" class="material-list">
      <div v-for="materialItem in materials" :key="materialItem.id" class="material-card">
        <!-- 辅料卡片左上角选择框 -->
        <el-checkbox v-model="materialItem.checked" class="material-checkbox" />
        <el-image class="material-image" :src="materialItem.material.main_image" fit="cover">
          <div slot="error" class="image-slot"><i class="el-icon-picture-outline" /></div>
        </el-image>
        <div class="material-info">
          <div class="material-name">{{ materialItem.material.name_trans || materialItem.material.name }}</div>
          <div class="material-type">
            {{ materialItem.material.type && (materialItem.material.type.name_trans || materialItem.material.type.name) }}
          </div>
          <div>库存数量：{{ materialItem.material.material_stock_num || 0 }}</div>
          <div class="material-consume-line">
            <span>消耗数量：</span>
            <el-input
              v-model="materialItem.consume"
              class="material-consume-input"
              size="mini"
              @input="sanitizeConsume(materialItem)"
            >
              <template slot="append">点/套</template>
            </el-input>
          </div>
        </div>
        <!-- 辅料库存状态 -->
        <div class="material-status" :class="statusClass(materialItem)">
          {{ statusText(materialItem) }}
        </div>
        <span class="material-use-count">辅料使用：{{ materialItem.consume * send_num }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 配送单预览页的辅料列表组件
  name: 'DeliveryPreviewMaterialList',
  props: {
    materials: { type: Array, default: () => [] },
    send_num: { type: [Number, String], default: 0 },
    expanded: { type: Boolean, default: true },
  },
  methods: {
    // 切换辅料列表的展开状态
    toggleExpanded() {
      this.$emit('update:expanded', !this.expanded)
    },
    // 辅料消耗只允许输入正整数
    sanitizeConsume(materialItem) {
      const digits = String(materialItem.consume == null ? '' : materialItem.consume).replace(/[^\d]/g, '')
      this.$set(materialItem, 'consume', digits === '' ? 0 : parseInt(digits, 10))
    },
    // 根据库存和消耗数量返回状态文字
    statusText(materialItem) {
      const stock = Number(materialItem.material && materialItem.material.material_stock_num || 0)
      return stock >= Number(materialItem.consume || 0) ? '库存充足' : '库存不足'
    },
    // 根据库存和消耗数量返回状态样式
    statusClass(materialItem) {
      const stock = Number(materialItem.material && materialItem.material.material_stock_num || 0)
      return stock >= Number(materialItem.consume || 0) ? 'stock-ok' : 'stock-error'
    },
  },
}
</script>

<style lang="scss" scoped>
// 辅料列表区域
.material-section {
  width: 100%;
  margin-top: -5px;
  border-top: 1px solid #ebeef5;
}

// 辅料列表标题和展开控制
.material-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 36px;
  padding: 0 18px;
  color: #606266;
  font-size: 14px;
}

// 辅料卡片排列
.material-list {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 20px;
  padding: 16px 18px;
}

// 单个辅料卡片尺寸和布局
.material-card {
  position: relative;
  display: flex;
  flex: 0 0 304px;
  align-items: flex-start;
  width: 304px;
  height: 205px;
  min-height: 205px;
  gap: 8px;
  padding: 14px 12px 50px 45px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  box-sizing: border-box;
  background: #fff;
}

// 卡片底部信息分隔线
.material-card::after {
  position: absolute;
  right: 12px;
  bottom: 48px;
  left: 12px;
  border-top: 1px solid #ebeef5;
  content: '';
}

// 辅料选择框固定在卡片左上角
.material-checkbox {
  position: absolute;
  top: 12px;
  left: 16px;
}

// 辅料图片尺寸
.material-image {
  flex: 0 0 80px;
  width: 80px;
  height: 80px;
  border-radius: 4px;
  background: #9b9b9b;
}

// 辅料文字信息
.material-info {
  flex: 1;
  min-width: 0;
  color: #606266;
  font-size: 14px;
  line-height: 20px;
}

.material-name {
  overflow: hidden;
  color: #333;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.material-type {
  display: inline-block;
  margin: 6px 0;
  padding: 0 6px;
  border-radius: 3px;
  background: #eaf2ff;
  color: #409eff;
  line-height: 20px;
}

// 辅料消耗输入框
.material-consume-line {
  display: flex;
  align-items: center;
  margin-top: 4px;
  white-space: nowrap;
}

.material-consume-input {
  width: 110px;
}

.material-consume-input /deep/ .el-input-group__append {
  padding: 0 6px;
  background: #fff;
}

// 辅料库存状态
.material-status {
  position: absolute;
  bottom: 12px;
  left: 12px;
  padding: 2px 5px;
  border-radius: 2px;
  font-size: 12px;
}

.stock-ok {
  color: #67c23a;
}

.stock-error {
  color: #f56c6c;
}

// 本次辅料使用数量
.material-use-count {
  position: absolute;
  right: 12px;
  bottom: 16px;
  white-space: nowrap;
}
</style>
